import { render, staticRenderFns } from "./charge-details-popup.vue?vue&type=template&id=a1b73b34&scoped=true&"
import script from "./charge-details-popup.vue?vue&type=script&lang=js&"
export * from "./charge-details-popup.vue?vue&type=script&lang=js&"
import style0 from "./charge-details-popup.vue?vue&type=style&index=0&id=a1b73b34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b73b34",
  null
  
)

export default component.exports